import type { TemplateBlockInstance } from '@/templates/domain/types';
import type { PageLayout } from './paginate';

/**
 * Cover-aware provisional pagination that does not need measured heights.
 *
 * Used while heights are still measuring so pageBreakAfter blocks (e.g. cover_page)
 * never share a page with following body blocks — avoids the pre-paginate flash of
 * "all blocks on page 1".
 */
export function buildProvisionalPageLayout(
  instances: TemplateBlockInstance[],
  pageBreakAfterIds: ReadonlySet<string>,
  pageBreakBeforeIds: ReadonlySet<string> = new Set()
): PageLayout {
  if (instances.length === 0) {
    return { pages: [] };
  }

  const pages: PageLayout['pages'] = [];
  let currentItems: PageLayout['pages'][number]['items'] = [];

  for (const instance of instances) {
    const instanceId = instance.templateBlockInstanceId;
    if (pageBreakBeforeIds.has(instanceId) && currentItems.length > 0) {
      pages.push({ items: currentItems });
      currentItems = [];
    }
    currentItems.push({ instanceId });
    if (pageBreakAfterIds.has(instanceId)) {
      pages.push({ items: currentItems });
      currentItems = [];
    }
  }

  if (currentItems.length > 0) {
    pages.push({ items: currentItems });
  }

  return { pages };
}
